import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios, { cookies } from "../../axios/axios";

const RetouchingEditorDetail = () => {
  const [retouching, setRetouching] = useState({});
  const [status, setStatus] = useState(1);
  const [selectedEditor, setSelectedEditor] = useState("");
  const [fileLocation, setFileLocation] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [message, setMessage] = useState("");

  const { id } = useParams();
  const navigate = useNavigate();

  const user = cookies.get("user");
  const userRole = user?.user?.role;
  const userName = user?.user?.fname;

  const getRetouchingById = async () => {
    try {
      const response = await axios.get(`/retouching/${id}`);
      setRetouching(response.data);
      setSelectedEditor(response.data.editor || "");
      setFileLocation(response.data.fileLocation || "");
      setStatus(response.data.status || 1);
    } catch (error) {
      seterrorMessage(error.response?.data?.message || "An error occurred");
    }
  };

  useEffect(() => {
    getRetouchingById();
  }, []);

  const updateRetouching = async () => {
    try {
      await axios.put(`/retouching/${id}`, {
        status,
        editor: userRole === "editor" ? userName : selectedEditor,
        fileLocation,
        message,
      });
      navigate("/retouching-editor");
    } catch (error) {
      seterrorMessage("Failed to update order");
    }
  };

  return (
    <div className="container mt-4">
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
      <div className="row">
        {/* Left Panel */}
        <div className="col-md-6">
          <div className="card mb-3">
            <div className="card-header fw-600">Job Details</div>
            <div className="card-body">
              <p>
                <strong>Event Name:</strong> {retouching.order_name}
              </p>
              <p>
                <strong>Service Type:</strong> {retouching?.serviceId?.service}
              </p>
              <p>
                <strong>Album Type:</strong> {retouching.order_name}
              </p>
            </div>
          </div>{" "}
          <div className="card mb-3">
            <div className="card-header fw-600">Job Details</div>
            <div className="card-body">
              <p>
                <strong>Cropping & Retouching :</strong>{" "}
                {retouching.cropping_straightening}
              </p>
              <p>
                <strong>Type of Shoot :</strong> {retouching.Image_type}
              </p>
              <p>
                <strong>Type of Image :</strong> {retouching.Image_type}
              </p>
              <p>
                <strong>Editing Style :</strong> {retouching.editing_style}
              </p>
              <p>
                <strong>White Balance :</strong> {retouching.white_balance}
              </p>
              <p>
                <strong>Noise Reduction :</strong> {retouching.noise_reduction}
              </p>
              <p>
                <strong>Lens Correction :</strong> {retouching.lens_correction}
              </p>
              <p>
                <strong>Black & White :</strong> {retouching.black_and_white}
              </p>
              <p>
                <strong>Black & White Percentage :</strong>{" "}
                {retouching.black_white_percentage}
              </p>{" "}
              <p>
                <strong>Need Sample for Review :</strong>{" "}
                {retouching.sample_for_review}
              </p>{" "}
              <p>
                <strong>Output Format :</strong> {retouching.output_format}
              </p>{" "}
              <p>
                <strong>Quantity:</strong> {retouching.quantity}
              </p>
              <p>
                <strong>Upload :</strong> {retouching.images}
              </p>
              <p>
                <strong>Additional Notes :</strong>{" "}
                {retouching.additional_notes}
              </p>
            </div>
          </div>
        </div>

        {/* Right Panel */}
        <div className="col-md-6">
          <div className="card mb-3">
            <div className="card-header fw-600">Order Operations</div>
            <div className="card-body">
              <p>
                <strong>Client ID:</strong> {user.user.id}
              </p>
              <p>
                <strong>Order ID:</strong> {retouching.id}
              </p>
              <p>
                <strong>User Feedback:</strong> {retouching.sampleFeedback}
              </p>
              <p>
                <strong>Sample Status:</strong>{" "}
                {retouching.sampleStatus === "approved" ? (
                  <span className="btn rounded-0 btn-success btn-sm p-2 ms-2">
                    Approved
                  </span>
                ) : retouching.sampleStatus === "declined" ? (
                  <span className="btn rounded-0 btn-danger btn-sm p-2 ms-2">
                    Declined
                  </span>
                ) : (
                  <span className="text-muted ms-2">Not Selected</span>
                )}
              </p>
              <p>
                <strong>Order Place Date:</strong>{" "}
                {new Date(retouching?.createdAt).toLocaleDateString()}
              </p>
              <div>
                <label className="form-label">Order Status</label>
                <select
                  className="form-select"
                  value={status}
                  onChange={(e) => setStatus(Number(e.target.value))}
                >
                  <option value={1}>New Order</option>
                  <option value={2}>In Process</option>
                  <option value={3}>On Hold</option>
                  <option value={4}>In QC</option>
                  <option value={5}>Sample Sent</option>
                  <option value={6}>In Revision</option>
                  <option value={7}>Cancelled</option>
                  <option value={8}>Completed</option>
                </select>{" "}
              </div>

              <div className="mt-3">
                <label className="form-label mt-3">Editor</label>
                <input
                  type="text"
                  className="form-control"
                  value={userName}
                  readOnly
                />
              </div>

              <label className="form-label mt-3">File Location</label>
              <input
                type="text"
                className="form-control"
                value={fileLocation}
                onChange={(e) => setFileLocation(e.target.value)}
              />

              <button
                onClick={updateRetouching}
                className="btn text-light bg_maincolor mt-3"
              >
                Update 
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RetouchingEditorDetail;
